
import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Zap, Users, Award, BookOpen } from 'lucide-react';
import FadeIn from '../../components/FadeIn';
import SEO from '../../components/SEO';

const TrainingHub = () => {
    const programs = [
        {
            title: "AI-Augmented BD",
            path: "/training/ai-bd",
            desc: "Leverage AI tools to supercharge your business development workflows.",
            icon: <Zap size={32} />,
            image: "https://images.unsplash.com/photo-1485827404703-89b55fcc595e?auto=format&fit=crop&q=80&w=800"
        },
        {
            title: "Experienced BD Track",
            path: "/training/experienced-bd",
            desc: "Advanced strategies for seasoned professionals targeting global markets.",
            icon: <Award size={32} />,
            image: "https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&q=80&w=800"
        },
        {
            title: "Aspiring BD Track",
            path: "/training/aspiring-bd",
            desc: "Launch your career with the foundational skills needed for success.",
            icon: <Users size={32} />,
            image: "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?auto=format&fit=crop&q=80&w=800"
        },
        {
            title: "Webinars & Events",
            path: "/training/webinars",
            desc: "Join our live sessions and learn from industry experts.",
            icon: <BookOpen size={32} />,
            image: "https://images.unsplash.com/photo-1544531886-983334309102?auto=format&fit=crop&q=80&w=800"
        }
    ];

    return (
        <div className="bg-white">
            <SEO
                title="Training Academy | BPO Consultants"
                description="World-class training for world-class talent. Explore our AI-augmented business development tracks and webinars."
            />

            {/* Hero */}
            <section className="relative pt-32 pb-20 px-4 sm:px-6 lg:px-8 bg-[#0B0D15] overflow-hidden">
                {/* Background Pattern */}
                <div className="absolute inset-0 opacity-20 pointer-events-none">
                    <svg className="h-full w-full" viewBox="0 0 100 100" preserveAspectRatio="none">
                        <path d="M0 100 C 20 0 50 0 100 100 Z" fill="#A2CB52" />
                    </svg>
                </div>

                <div className="max-w-7xl mx-auto relative z-10 text-center">
                    <FadeIn>
                        <h1 className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight">
                            AntiGravity Academy
                        </h1>
                        <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
                            Elite training for the next generation of global talent. <br className="hidden md:block" />
                            <strong>Master the skills that matter.</strong>
                        </p>
                    </FadeIn>
                </div>
            </section>

            {/* Programs Grid */}
            <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gray-50">
                <div className="max-w-7xl mx-auto">
                    <div className="grid md:grid-cols-2 gap-8">
                        {programs.map((program, index) => (
                            <FadeIn key={index} delay={index * 0.1}>
                                <Link to={program.path} className="block group h-full">
                                    <div className="bg-white rounded-2xl shadow-lg run-over overflow-hidden border border-gray-100 hover:shadow-2xl transition-all h-full flex flex-col relative">
                                        <div className="h-48 overflow-hidden relative">
                                            <img
                                                src={program.image}
                                                alt={program.title}
                                                className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-500"
                                            />
                                            <div className="absolute inset-0 bg-gradient-to-t from-[#0B0D15]/80 to-transparent"></div>
                                            <div className="absolute bottom-4 left-4 text-white font-bold text-xl flex items-center">
                                                <span className="bg-[#A2CB52] text-[#0B0D15] p-2 rounded-lg mr-3">
                                                    {program.icon}
                                                </span>
                                                {program.title}
                                            </div>
                                        </div>
                                        <div className="p-8 flex-1 flex flex-col">
                                            <p className="text-gray-600 mb-6 flex-1 text-lg">
                                                {program.desc}
                                            </p>
                                            <div className="flex items-center text-[#A2CB52] font-bold group-hover:translate-x-2 transition-transform">
                                                View Curriculum <ArrowRight size={20} className="ml-2" />
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                            </FadeIn>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
};

export default TrainingHub;
